import React from 'react';
import { Typography } from '@material-ui/core';
import { getAsLongDateTime } from '../../../../common-client2/src/services/ukgDateTime';
import './SubmissionPeriodLabel.scss';

const SubmissionPeriodLabel = ({ request }) => (
    <Typography className="submission-period-label">
        Submission period: {`${getAsLongDateTime(request.submissionPeriod_StartDate)} to ${getAsLongDateTime(request.submissionPeriod_EndDate)}`}
    </Typography>
)
export default SubmissionPeriodLabel;
